import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Review from './Review/Review';

class ReviewComponent extends React.Component{

  state={
    controlSidebarOpen: false,
    googleReviews: [],
    hasError: false,
  }

  componentDidMount(){
    fetch("http://breezeview.breezereview.com/breezeview/1")
    .then(res => res.json())
    .then(data => {
      if(data && data !== ""){
        this.setState({googleReviews: data.reviews});
      }
    })
    .catch(err => this.setState({hasError: true}));
  }

  btnCLickHandler = () => {
    this.setState((prevstate) => {
      return {controlSidebarOpen: !prevstate.controlSidebarOpen}
    });
  }

  countImpressionsAndClick = (event) => {
    let postData = {
      type: ''
    }
    if(event.type === 'click'){
      postData.type='click';
    }
    if(event.type === 'mouseover'){
      postData.type='impression';
    }
    fetch("http://breezeview.breezereview.com/breezeview/1",{
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(postData)
    });
  }
  
  render(){
    let classList = ['bmw-ControlSidebar'];
    this.state.controlSidebarOpen && classList.push('bmw-ControlSideBarOpen');
  //  To handle error while fetching data
    let reviewContent = (
                          <div className={'bmw-ReviewsContainer'}>
                              {this.state.googleReviews.map(review => {
                                return <Review key={review.author_name} 
                                name={review.author_name}
                                time={review.time}
                                body={review.text} />
                              })}
                          </div>);
    if(this.state.hasError){
      reviewContent = <h4 style={{textAlign:"center", padding:"8px"}}>Error! Something went wrong.</h4>
    }
    return (
      <React.Fragment>
      <button className={'bmw-ReviewBtn'} onMouseOver={this.countImpressionsAndClick} onClick={(event) => {this.countImpressionsAndClick(event);this.btnCLickHandler()}}>
        {/* <img src='./images/Google-Button-Powered-by-Google.png' alt='Google-rating' className={'bmw-ReviewBtnImage'} /> */}
      </button>
      <aside className={classList.join(' ')}>
          <div className={'bmw-ControlSidebarHead'}>
              <h3>Google Reviews</h3>
              <button onClick={this.btnCLickHandler} className={'bmw-CloseBtn'}>
                  <i className={'fa fa-close fa-lg'}></i>
              </button>
          </div>
          {reviewContent}
      </aside>
      </React.Fragment>
    )
  }
}



ReactDOM.render(
    <ReviewComponent />,
  document.getElementById('bmw_google_reviews')
);